import dayjs from "dayjs";

// 格式化日期：今天显示 "Today HH:mm"，其他显示 "MMM DD"
export const formatTADate = (date: string | number | Date) => {
  const dateObj = dayjs(date);
  const isToday = dayjs().isSame(dateObj, "day");
  if (isToday) {
    return `Today ${dateObj.format("HH:mm")}`;
  }
  return dateObj.format("MMM DD");
};

/** 时间列 HH:mm:ss */
export const formatTATableTime = (date: string | number | Date) =>
  dayjs(date).format("HH:mm:ss");

/** 日期标题 Today  MMM DD YYYY */
export const formatTATableDateHeader = (date: string | number | Date) => {
  const dateObj = dayjs(date);
  const isToday = dayjs().isSame(dateObj, "day");
  return isToday
    ? `Today  ${dateObj.format("MMM DD YYYY")}`
    : dateObj.format("MMM DD YYYY");
};
